export const validateCodeFeatures = (
  formValues: Record<string, any>,
  keyPrefix: string,
  valueToMatch: any = true,
  codeIndex: number = 4
): boolean => {
  const filteredKeys = Object.keys(formValues).filter(
    (key) => key.includes(keyPrefix) && formValues[key] === valueToMatch
  );

  const equivalentes = filteredKeys.map((item) => item.split('-')[codeIndex]);

  const countMap = equivalentes.reduce((acc, equivalente) => {
    acc[equivalente] = (acc[equivalente] || 0) + 1;
    return acc;
  }, {} as Record<string, number>);

  return Object.values(countMap).some((count) => count >= 2);
};

export const isValidCodeRenew = (value?: string | null): boolean => {
  return !!value && value !== "0" && value !== "undefined";
};
